export default class UserUtil {
    constructor (user) {
        this.user = user
    }

    isDealCustomer() {
        return this.user.account_type === 'deal'
    }

    isCustomer() {
        return this.user.account_type === 'pro'
    }

    isAdmin() {
        return this.user.role === 'admin' || process.env.NODE_ENV === 'development'
    }

    isAdminOrOwner() {
        return this.user.role === 'admin' || this.user.role === 'owner'
    }

    hasAiTokens() {
        // TODO: implement!

        // console.log('TODO: set isCustomer and hasAiTokens variables correctly')
        let isCustomer = true
        let hasAiTokens = true

        return true
    }
}